import { Publication, SanityKeyed } from "@libry-content/types";
import { useTranslation } from "../../utils/hooks/useTranslation";

export const useRelevantPublicationsHeading = (relevantPublications: Array<SanityKeyed<Publication>> | undefined) => {
  const { t } = useTranslation();
  const relevantPublicationWorkTypes = relevantPublications?.flatMap((publication) => publication.workType);
  const unqiueWorkTypes = Array.from(new Set(relevantPublicationWorkTypes));

  if (!unqiueWorkTypes.length || unqiueWorkTypes.length < 1) return;

  if (unqiueWorkTypes.length > 1) return t("Relatert materiale");

  switch (unqiueWorkTypes?.[0]) {
    case "Interactive work":
      return t("Relaterte spill");
    case "Language based work":
      return t("Relatert litteratur");
    case "Moving image work":
      return t("Relaterte filmer");
    case "Musical work":
      return t("Relatert musikk");
    default:
      return t("Relatert materiale");
  }
};
